import React, { useState } from "react";

const MyPreferencesComponent = () => {
  const [isFemaleOnly, setIsFemaleOnly] = useState(false);
  const [isMaleOnly, setIsMaleOnly] = useState(false);
  const [isNonSmoker, setIsNonSmoker] = useState(false);
  const [isNoPets, setIsNoPets] = useState(false);
  const [isNoPreferences, setIsNoPreferences] = useState(false);

  return (
    <div className="my-preferences-custom-component-container">
      <div className="my-preferences-indicative-above-div">
        <h2>My preferences</h2>
        <h3>Who do you prefer to work with?</h3>
      </div>
      <div className="my-preferences-checkbox-section">
        <div className="checkbox-item">
          <input
            type="checkbox"
            checked={isFemaleOnly}
            onChange={() => setIsFemaleOnly(!isFemaleOnly)}
          />
          <label>Female only</label>
        </div>

        <div className="checkbox-item">
          <input
            type="checkbox"
            checked={isMaleOnly}
            onChange={() => setIsMaleOnly(!isMaleOnly)}
          />
          <label>Male only</label>
        </div>

        <div className="checkbox-item">
          <input
            type="checkbox"
            checked={isNonSmoker}
            onChange={() => setIsNonSmoker(!isNonSmoker)}
          />
          <label>Non-smoker</label>
        </div>

        <div className="checkbox-item">
          <input
            type="checkbox"
            checked={isNoPets}
            onChange={() => setIsNoPets(!isNoPets)}
          />
          <label>No pets</label>
        </div>

        <div className="checkbox-item">
          <input
            type="checkbox"
            checked={isNoPreferences}
            onChange={() => setIsNoPreferences(!isNoPreferences)}
          />
          <label>No preferences</label>
        </div>
      </div>

      <div className="my-preferences-save">
        <button>Save and continue</button>
      </div>
    </div>
  );
};

export default MyPreferencesComponent;
